import React from 'react';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import {Box} from "@mui/material";
import Tabs from './Tabs'
import './News_Blog.css'

const News_Blog: React.FC = () => {
    return (
        <Box className='newsBlog-page'>
            <Header/>
            <Box className="ellipse11"></Box>
            <Box className="ellipse22"></Box>
            <Box className="linear"></Box>
            <Box className='hero-ourgame'></Box>
            <Tabs/>
            <Footer/>
        </Box>
    );
};

export default News_Blog;